import { batch } from 'react-redux';
import { addIndication } from 'modules/taboola-common-frontend-modules/Indications';
import { accountsApi } from 'services/api';
import { updateAccountSuccess } from '../actions/updateAccountSuccess';
import { generateErrorIndication, successIndication } from '../hooks/useAccountEditorState';

export const updateAccount =
    ({ accountId, accountName, isActive, adminNetworkAccountId }) =>
    async dispatch => {
        try {
            const updateAccountResponse = await accountsApi.updateAdvertiser(accountName, {
                isActive,
                adminNetworkAccountId,
            });

            batch(() => {
                dispatch(updateAccountSuccess({ ...updateAccountResponse, id: accountId }));
                dispatch(addIndication(successIndication));
            });

            return updateAccountResponse;
        } catch (error) {
            dispatch(addIndication(generateErrorIndication(error)));
            // We overwrite data to trigger selector with old report data
            dispatch(updateAccountSuccess({ id: accountId, timeStamp: Date.now() }));
            throw error;
        }
    };
